import { extractNumber } from '@/lib/utils';
import Decimal from 'decimal.js';
import { CopilotValue3 } from '@/stores/types/copilotValue/copilotValue3';

export const calculateAdjustment = (copilotValue3: Partial<CopilotValue3>) => {
  const zero = new Decimal(0);
  const beforeTotalData = new Decimal(extractNumber(copilotValue3.cash_before || '0'))
    .plus(extractNumber(copilotValue3.stable_before || '0'))
    .plus(extractNumber(copilotValue3.aggressive_before || '0'));
  let cash_beforeRatio = new Decimal(extractNumber(copilotValue3.cash_before || '0'))
    .div(beforeTotalData)
    .times(100)
    .round();
  let stable_beforeRatio = new Decimal(extractNumber(copilotValue3.stable_before || '0'))
    .div(beforeTotalData)
    .times(100)
    .round();
  let aggressive_beforeRatio = new Decimal(extractNumber(copilotValue3.aggressive_before || '0'))
    .div(beforeTotalData)
    .times(100)
    .round();

  const sumBefore = cash_beforeRatio.plus(stable_beforeRatio).plus(aggressive_beforeRatio);
  const diffBefore = new Decimal(100).minus(sumBefore);

  if (!diffBefore.isZero()) {
    if (cash_beforeRatio.gte(stable_beforeRatio) && cash_beforeRatio.gte(aggressive_beforeRatio)) {
      cash_beforeRatio = cash_beforeRatio.plus(diffBefore);
    } else if (stable_beforeRatio.gte(aggressive_beforeRatio)) {
      stable_beforeRatio = stable_beforeRatio.plus(diffBefore);
    } else {
      aggressive_beforeRatio = aggressive_beforeRatio.plus(diffBefore);
    }
  }

  const afterTotalData = new Decimal(extractNumber(copilotValue3.cash_after || '0'))
    .plus(extractNumber(copilotValue3.stable_after || '0'))
    .plus(extractNumber(copilotValue3.aggressive_after || '0'));
  // 计算百分比并保留整数，确保三者相加等于100
  let cash_afterRatio = new Decimal(extractNumber(copilotValue3.cash_after || '0'))
    .div(afterTotalData)
    .times(100)
    .round();
  let stable_afterRatio = new Decimal(extractNumber(copilotValue3.stable_after || '0'))
    .div(afterTotalData)
    .times(100)
    .round();
  let aggressive_afterRatio = new Decimal(extractNumber(copilotValue3.aggressive_after || '0'))
    .div(afterTotalData)
    .times(100)
    .round();

  // 确保三者相加等于100，调整最大的一项
  const sum = cash_afterRatio.plus(stable_afterRatio).plus(aggressive_afterRatio);
  const diff = new Decimal(100).minus(sum);

  if (!diff.isZero()) {
    // 找出最大的比例进行调整
    if (cash_afterRatio.gte(stable_afterRatio) && cash_afterRatio.gte(aggressive_afterRatio)) {
      cash_afterRatio = cash_afterRatio.plus(diff);
    } else if (stable_afterRatio.gte(aggressive_afterRatio)) {
      stable_afterRatio = stable_afterRatio.plus(diff);
    } else {
      aggressive_afterRatio = aggressive_afterRatio.plus(diff);
    }
  }

  const cash_trend = cash_afterRatio.minus(cash_beforeRatio);
  const stable_trend = stable_afterRatio.minus(stable_beforeRatio);
  const aggressive_trend = aggressive_afterRatio.minus(aggressive_beforeRatio);
  return {
    cash_beforeRatio: cash_beforeRatio.toString() === 'NaN' ? zero : cash_beforeRatio,
    cash_afterRatio: cash_afterRatio.toString() === 'NaN' ? zero : cash_afterRatio,
    stable_beforeRatio: stable_beforeRatio.toString() === 'NaN' ? zero : stable_beforeRatio,
    stable_afterRatio: stable_afterRatio.toString() === 'NaN' ? zero : stable_afterRatio,
    aggressive_beforeRatio:
      aggressive_beforeRatio.toString() === 'NaN' ? zero : aggressive_beforeRatio,
    aggressive_afterRatio:
      aggressive_afterRatio.toString() === 'NaN' ? zero : aggressive_afterRatio,
    cash_trend: cash_trend.toString() === 'NaN' ? zero : cash_trend,
    stable_trend: stable_trend.toString() === 'NaN' ? zero : stable_trend,
    aggressive_trend: aggressive_trend.toString() === 'NaN' ? zero : aggressive_trend
  };
};
